import { render, staticRenderFns } from "./Decoration.vue?vue&type=template&id=50a05b01&scoped=true&"
import script from "./Decoration.vue?vue&type=script&lang=js&"
export * from "./Decoration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a05b01",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50a05b01')) {
      api.createRecord('50a05b01', component.options)
    } else {
      api.reload('50a05b01', component.options)
    }
    module.hot.accept("./Decoration.vue?vue&type=template&id=50a05b01&scoped=true&", function () {
      api.rerender('50a05b01', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/carbonclap/components/reporting/Decoration.vue"
export default component.exports